/**
 * Theme palette key references for use across the codebase.
 * Use these instead of hex codes or rgba values for theme-aware styling.
 *
 * Usage with MUI sx prop:
 *   sx={{ color: theme.palette.text.primary, bgcolor: theme.palette.background.paper }}
 *
 * For opacity/alpha values, use MUI's alpha():
 *   import { alpha } from '@mui/material/styles';
 *   alpha(theme.palette.primary.main, 0.1)
 */

export const PALETTE_KEYS = {
  // Background
  BACKGROUND_DEFAULT: 'background.default',
  BACKGROUND_PAPER: 'background.paper',
  BACKGROUND_HOVER: 'action.hover',

  // Text
  TEXT_PRIMARY: 'text.primary',
  TEXT_SECONDARY: 'text.secondary',
  TEXT_DISABLED: 'text.disabled',

  // Semantic
  PRIMARY_MAIN: 'primary.main',
  SUCCESS_MAIN: 'success.main',
  ERROR_MAIN: 'error.main',
  WARNING_MAIN: 'warning.main',
  INFO_MAIN: 'info.main',

  // Borders & dividers
  DIVIDER: 'divider',

  // Common
  COMMON_WHITE: 'common.white',
  COMMON_BLACK: 'common.black',

  // Grey scale (for neutral surfaces)
  GREY_50: 'grey.50',
  GREY_100: 'grey.100',
  GREY_200: 'grey.200',
  GREY_300: 'grey.300',
  GREY_400: 'grey.400',
  GREY_500: 'grey.500',
  GREY_600: 'grey.600',
  GREY_700: 'grey.700',
  GREY_800: 'grey.800',
  GREY_900: 'grey.900',
} as const;
